import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import PropTypes from 'prop-types';

const maxPages = 6;

export default class BasePagination extends React.Component {
  static arrayRange(start, stop, step, lastPage) {
    return Array.from(
      { length: (Math.min(stop, lastPage) - start) / step + 1 },
      (value, index) => start + index * step,
    );
  }

  handleSwitchPage = (event, page) => {
    event.preventDefault();
    this.props.switchPage(page);
  };

  render() {
    const { lastPage, currentPage } = this.props;
    let pages = [];

    if (lastPage > maxPages) { // if we have more pages than alloted buttons
      if (currentPage > lastPage - maxPages) { // within the last X pages show last X pages always
        pages = BasePagination.arrayRange(lastPage - maxPages + 1, lastPage, 1, lastPage);
      } else {
        pages = BasePagination.arrayRange(
          Math.max(1, currentPage - 2),
          currentPage + maxPages - 1,
          1,
          lastPage,
        );
      }
    } else { // there are less pages than alloted buttons
      pages = BasePagination.arrayRange(1, currentPage + maxPages - 1, 1, lastPage);
    }

    let jsx = null;
    if (lastPage > 1 || currentPage > 1) {
      jsx = (
        <Pagination>
          <PaginationItem disabled={currentPage <= 1}>
            <PaginationLink
              previous
              href="#"
              onClick={(event) => {
                this.handleSwitchPage(event, currentPage - 1);
              }}
            />
          </PaginationItem>

          {pages.map((x) => (
            <PaginationItem key={x} active={currentPage === x}>
              <PaginationLink
                href="#"
                onClick={(event) => {
                  this.handleSwitchPage(event, x);
                }}
              >
                {x}
              </PaginationLink>
            </PaginationItem>
          ))}

          <PaginationItem disabled={currentPage >= lastPage}>
            <PaginationLink
              next
              href="#"
              onClick={(event) => {
                this.handleSwitchPage(event, currentPage + 1);
              }}
            />
          </PaginationItem>
        </Pagination>
      );
    }

    return jsx;
  }
}

BasePagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  lastPage: PropTypes.number.isRequired,
  switchPage: PropTypes.func.isRequired,
};
